// extracted by mini-css-extract-plugin
export default {"buttons":"ProcessRowDescriptions_buttons__XiDuS"};